export default __webpack_public_path__ + "static/media/logo.7f1a2375.png";